import { default as _91id_93aNGSC2BxW1Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue?macro=true";
import { default as accountsg0E79ID3GEMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue?macro=true";
import { default as analyticstRlsuE0KhYMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue?macro=true";
import { default as contactszX2lbHkthPMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue?macro=true";
import { default as indexoinekd46KRMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue?macro=true";
import { default as mailboxesQKwKe2FEhgMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue?macro=true";
import { default as newU1bmhvxFrLMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue?macro=true";
import { default as schedulevXfq5skaAVMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue?macro=true";
import { default as _91sequenceId_93FL0UvVW9qfMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue?macro=true";
import { default as indexA21eLrTiknMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue?macro=true";
import { default as newE0ljBz4H1eMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue?macro=true";
import { default as outreach3kHm8DYGjwMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue?macro=true";
import { default as setupepCzDU5mFDMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue?macro=true";
import { default as _91icp_93AH7zTEQC95Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue?macro=true";
import { default as index6iQfkdJjdVMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue?macro=true";
import { default as campaignsG2hR0BMzNzMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue?macro=true";
import { default as discover01FDlRKTtTMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue?macro=true";
import { default as indexnmkP5YZI1eMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue?macro=true";
import { default as opensSQJql6QRazMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue?macro=true";
import { default as repliesBiYHbdyQJZMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue?macro=true";
import { default as _91listId_93OeHbloyLdmMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue?macro=true";
import { default as allmcNgAxDhkrMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue?macro=true";
import { default as mine2K3XiLy7ESMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue?macro=true";
import { default as sequencesm78JY4HL6cMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue?macro=true";
import { default as accountUquHj5bMN4Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue?macro=true";
import { default as engaged_45accountsxy76jLSG9pMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue?macro=true";
import { default as engaged_45contacts2gcU1ILUsYMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue?macro=true";
import { default as exportsLOe5NUkl6IMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue?macro=true";
import { default as forbidden_45accounts1D9ePfA2AHMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue?macro=true";
import { default as forbidden_45contactsfZTwRn1UOpMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue?macro=true";
import { default as importsTouiE7S0SYMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue?macro=true";
import { default as indexpaYQjmyKS1Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsQHXG68iZ1AMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue?macro=true";
import { default as mailboxAVQZq8kmpdMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue?macro=true";
import { default as notificationsCQtIl0owFPMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue?macro=true";
import { default as organizationgDUo59D796Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue?macro=true";
import { default as repliescGleuEAhTLMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue?macro=true";
import { default as settingsxEqVnWMg43Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue?macro=true";
import { default as advanced_45icpEWVtrg0LD0Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue?macro=true";
import { default as advancedfEsJfQtqxGMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue?macro=true";
import { default as employeesfhuPI6v34QMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue?macro=true";
import { default as job_45openingsppqRVZ3lvTMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue?macro=true";
import { default as newsf6zaVMYUJoMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue?macro=true";
import { default as websiteshRknCoXwgLMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue?macro=true";
import { default as signin5LbgUHGQD6Meta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue?macro=true";
import { default as signupwDgmthnpCYMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue?macro=true";
import { default as testZlZGeYNv6CMeta } from "/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue?macro=true";
export default [
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue")
  },
  {
    name: campaignsG2hR0BMzNzMeta?.name,
    path: "/campaigns",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue"),
    children: [
  {
    name: "campaigns-icp",
    path: ":icp()",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-accounts",
    path: "accounts",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue")
  },
  {
    name: "campaigns-icp-analytics",
    path: "analytics",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue")
  },
  {
    name: outreach3kHm8DYGjwMeta?.name,
    path: "outreach",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue"),
    children: [
  {
    name: _91sequenceId_93FL0UvVW9qfMeta?.name,
    path: ":sequenceId()",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue"),
    children: [
  {
    name: "campaigns-icp-outreach-sequenceId-contacts",
    path: "contacts",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId",
    path: "",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-mailboxes",
    path: "mailboxes",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-new",
    path: "new",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-schedule",
    path: "schedule",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue")
  }
]
  },
  {
    name: "campaigns-icp-outreach",
    path: "",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue")
  },
  {
    name: "campaigns-icp-outreach-new",
    path: "new",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue")
  }
]
  },
  {
    name: "campaigns-icp-setup",
    path: "setup",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue")
  }
]
  },
  {
    name: "campaigns",
    path: "",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue")
  }
]
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue")
  },
  {
    name: "sequences",
    path: "/sequences",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue")
  },
  {
    name: settingsxEqVnWMg43Meta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue")
  },
  {
    name: "settings-engaged-accounts",
    path: "engaged-accounts",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue")
  }
]
  },
  {
    name: "signals-advanced-icp",
    path: "/signals/advanced-icp",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue")
  },
  {
    name: "signals-advanced",
    path: "/signals/advanced",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue")
  },
  {
    name: "signals-employees",
    path: "/signals/employees",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue")
  },
  {
    name: "signals-job-openings",
    path: "/signals/job-openings",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue")
  },
  {
    name: "signals-news",
    path: "/signals/news",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue")
  },
  {
    name: "signals-websites",
    path: "/signals/websites",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/codebuild/output/src3659515855/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue")
  }
]